import Vue from "vue";

export async function getAppraisals(params = {}) {
  const response = await Vue.prototype.$http.get("/services/appraisals", {
    params,
  });

  return response.data;
}